import React, { useEffect, useState } from 'react';
import "./EditCourse.css"
import { useLocation, useNavigate } from 'react-router-dom';
import { MAIN_URL } from '../../constants';
import axios from 'axios'
import { toast } from 'react-toastify';
import api from '../../Components/RefreshToken/RefreshToken';
import SortableChapter from './SortableChapter'
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'
import {
    DndContext,
    closestCenter,
    useSensor,
    useSensors,
    PointerSensor,
} from "@dnd-kit/core";
import {
    SortableContext,
    arrayMove,
} from "@dnd-kit/sortable";
import { ArrowLeft, BookOpen, FileText, ImageUp, ZoomIn } from 'lucide-react';
import { Badge, Button, Card, EmptyState, Input, Modal, PageHeader, SegmentedControl, Select } from '../../Components/ui';
import './EditCoursePage.css';
import CourseThumbnail from '../../Components/Courses/CourseThumbnail';

const LANGS = ["uz", "ru", "en"];

// Faqat ko'rsatish uchun: 4999990 → "4 999 990 so'm"
const formatPrice = (price) => {
    if (price === null || price === undefined || price === '') return null;
    const number = Number(price);
    if (Number.isNaN(number)) return null;
    return `${new Intl.NumberFormat('ru-RU').format(number)} so'm`;
};

// Til tugmasi: nom + nuqta (tarjima bor — yashil, yo'q — kulrang)
const langOption = (lang, hasTranslation) => ({
    value: lang,
    label: (
        <span className="ui-edit-course__lang">
            {lang.toUpperCase()}
            <span className={`ui-edit-course__lang-dot ${hasTranslation ? 'ui-edit-course__lang-dot--on' : ''}`} aria-hidden="true" />
        </span>
    ),
});

const UpdateCourse = () => {
    const location = useLocation()
    const selectCourses = location.state?.course
    const TOKEN = localStorage.getItem('admin_token')
    const courseId = location.state?.course?.id;

    const [mentors, setMentors] = useState([])
    const [imgOpen, setImgOpen] = useState(false)
    const [chapters, setChapters] = useState([])
    const [activeChapter, setActiveChapter] = useState()
    const [chapterId, setChapterId] = useState()
    const [lessons, setLessons] = useState()
    const [chapterEdit, setChapterEdit] = useState(false)
    const [chapterUpLoad, setChapterUpLoad] = useState(false)
    const [selectedMentorId, setSelectedMentorId] = useState(selectCourses?.mentor?.id || "")
    const [chapterName, setChapterName] = useState({ id: "", title: "" })
    const [chapterFile, setChapterFile] = useState()
    const [isHovered, setIsHovered] = useState(false)
    const [selectedFile, setSelectedFile] = useState(null)
    const [sortedChapters, setSortedChapters] = useState([])
    const [isOrderChanged, setIsOrderChanged] = useState(false)
    const [image, setImage] = useState("")

    const [courseName, setCourseName] = useState({
        id: courseId,
        price: selectCourses?.price || "",
        mentor: `${selectCourses?.mentor?.first_name} ${selectCourses?.mentor?.last_name}`,
        image: ""
    });

    // ─── Course Translations ─────────────────────────────────────────────────────
    const [activeLanguage, setActiveLanguage] = useState("uz")
    const [translations, setTranslations] = useState({
        uz: { title: "", description: "", translation_id: null },
        ru: { title: "", description: "", translation_id: null },
        en: { title: "", description: "", translation_id: null },
    })
    const langFlags = { uz: "🇺🇿", ru: "🇷🇺", en: "🇬🇧" }
    // ─────────────────────────────────────────────────────────────────────────────

    // ─── Chapter Translation Modal state ─────────────────────────────────────────
    // chapterTranslationModal — qaysi chapter uchun modal ochiq
    const [chapterTranslationModal, setChapterTranslationModal] = useState(null)
    // chapterTranslations — modal ichidagi til state lari
    // Struktura: { uz: { title, translation_id }, ru: { title, translation_id }, en: { title, translation_id } }
    const [chapterTranslations, setChapterTranslations] = useState({
        uz: { title: "", translation_id: null },
        ru: { title: "", translation_id: null },
        en: { title: "", translation_id: null },
    })
    const [chapterTranslationFile, setChapterTranslationFile] = useState(null)
    const [activeChapterLang, setActiveChapterLang] = useState("uz")
    // ─────────────────────────────────────────────────────────────────────────────

    // ─── Kurs detail ─────────────────────────────────────────────────────────────
    useEffect(() => {
        if (!courseId) return;
        api.get(`/courses/detail/${courseId}`, {
            headers: { Authorization: `Bearer ${TOKEN}` }
        })
            .then((res) => {
                const data = res.data;
                setCourseName({
                    id: data.id,
                    price: data.price,
                    mentor: `${data.mentor?.first_name} ${data.mentor?.last_name}`,
                    image: data.photo || ""
                });
                setImage(data.photo || "");
                setSelectedMentorId(data.mentor?.id);

                // Course translations
                if (data.translations && Array.isArray(data.translations)) {
                    const mapped = {
                        uz: { title: "", description: "", translation_id: null },
                        ru: { title: "", description: "", translation_id: null },
                        en: { title: "", description: "", translation_id: null },
                    };
                    data.translations.forEach((t) => {
                        if (mapped[t.language] !== undefined) {
                            mapped[t.language] = {
                                title: t.title || "",
                                description: t.description || "",
                                translation_id: t.id,
                            };
                        }
                    });
                    setTranslations(mapped);
                }

                if (data.chapters) setChapters(data.chapters);
            })
            .catch(() => toast.error("Kurs ma'lumotlarini yuklashda xatolik!"));
    }, [courseId]);
    // ─────────────────────────────────────────────────────────────────────────────

    // ─── Mentorlar ───────────────────────────────────────────────────────────────
    useEffect(() => {
        api.get(`/management/mentors`, {
            headers: { "Content-Type": "application/json", "Authorization": `Bearer ${TOKEN}` },
        }).then((res) => setMentors(res?.data || []))
            .catch((err) => console.log("Mentorlar xatosi:", err))
    }, [])
    // ─────────────────────────────────────────────────────────────────────────────

    // ─── Chapterlar ──────────────────────────────────────────────────────────────
    // useEffect(() => {
    //     if (!courseId) return;
    //     api.get(`/courses/chapters`, {
    //         headers: { Authorization: `Bearer ${TOKEN}` },
    //         params: { course_id: courseId },
    //     })
    //         .then((res) => setChapters(res.data))
    //         .catch((err) => toast.error(`Chapterlar xatosi: ${err.message}`));
    // }, [])
    // ─────────────────────────────────────────────────────────────────────────────

    // ─── Lessons ─────────────────────────────────────────────────────────────────
    useEffect(() => {
        if (!chapterId) return;
        api.get(`/courses/chapters/${chapterId}/lessons`, {
            headers: { Authorization: `Bearer ${TOKEN}` },
        }).then((res) => setLessons(res.data))
            .catch((err) => console.log(err))
    }, [chapterId])
    // ─────────────────────────────────────────────────────────────────────────────

    // ─── Chapter sort ─────────────────────────────────────────────────────────────
    useEffect(() => {
        if (chapters?.length) {
            setSortedChapters(chapters.slice().sort((a, b) => a.order - b.order));
        }
    }, [chapters]);

    useEffect(() => {
        if (!isOrderChanged) return;
        axios.post(
            `${MAIN_URL}/courses/chapters/change-order`,
            sortedChapters.map((ch, index) => ({ id: ch.id, order: index + 1 })),
            { headers: { "Content-Type": "application/json", Authorization: `Bearer ${TOKEN}` } }
        ).then(() => setIsOrderChanged(false))
            .catch((err) => console.error("Order xatosi:", err));
    }, [sortedChapters, isOrderChanged]);
    // ─────────────────────────────────────────────────────────────────────────────

    // ─── Chapter Translation Modal ochish ────────────────────────────────────────
    // chapter.translations = [{id, title, language}, ...]  dan olinadi
    const openChapterTranslationModal = (chapter) => {
        setActiveChapterLang("uz")
        setChapterTranslationFile(null)

        const mapped = {
            uz: { title: "", translation_id: null },
            ru: { title: "", translation_id: null },
            en: { title: "", translation_id: null },
        };

        if (chapter.translations && Array.isArray(chapter.translations)) {
            chapter.translations.forEach((t) => {
                if (mapped[t.language] !== undefined) {
                    mapped[t.language] = {
                        title: t.title || "",
                        translation_id: t.id, // <── PUT ga yuboriladi
                    };
                }
            });
        }

        setChapterTranslations(mapped);
        setChapterTranslationModal(chapter); // modal uchun chapter ni saqlaymiz
    };

    const closeChapterTranslationModal = () => {
        setChapterTranslationModal(null);
        setChapterTranslationFile(null);
    };

    const handleChapterTranslationChange = (lang, value) => {
        setChapterTranslations((prev) => ({
            ...prev,
            [lang]: { ...prev[lang], title: value },
        }));
    };

    // PUT /courses/chapters/translations/{translation_id}
    // body: multipart/form-data — title (required), exam_pdf (optional)
    const updateChapterTranslation = (lang) => {
        const t = chapterTranslations[lang];
        if (!t.translation_id) {
            toast.warning(`${lang.toUpperCase()} tarjimasi ID si topilmadi!`);
            return;
        }
        if (!t.title.trim()) {
            toast.warning("Title bo'sh bo'lishi mumkin emas!");
            return;
        }

        const formData = new FormData();
        formData.append("title", t.title);
        if (chapterTranslationFile) {
            formData.append("exam_pdf", chapterTranslationFile);
        }

        axios.put(
            `${MAIN_URL}/courses/chapters/translations/${t.translation_id}`,
            formData,
            {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: `Bearer ${TOKEN}`,
                },
            }
        )
            .then(() => {
                toast.success(`${langFlags[lang]} ${lang.toUpperCase()} chapter tarjimasi saqlandi!`);
                // chapters state ni yangilaymiz
                setChapters((prev) =>
                    prev.map((ch) => {
                        if (ch.id !== chapterTranslationModal?.id) return ch;
                        return {
                            ...ch,
                            translations: ch.translations?.map((tr) =>
                                tr.id === t.translation_id ? { ...tr, title: t.title } : tr
                            ),
                        };
                    })
                );
            })
            .catch((err) => toast.error(`Xatolik: ${err.message}`));
    };
    // ─────────────────────────────────────────────────────────────────────────────

    const handleImgChange = (e) => {
        const file = e.target.files[0];
        if (file) { setImage(URL.createObjectURL(file)); setSelectedFile(file); }
    };
    const handleImgOpen = () => setImgOpen(x => !x)
    const handleChapter = (id, index) => {
        setActiveChapter(activeChapter === index ? null : index);
        setChapterId(activeChapter === index ? null : id)
    }
    const handleChapterEdit = (index) => setChapterEdit(chapterEdit === index ? null : index)
    const handleFileChange = (e) => { const file = e.target.files[0]; if (file) setChapterFile(file); }
    const handleUpCapter = () => setChapterUpLoad(true)
    const sensors = useSensors(useSensor(PointerSensor));
    const handleDragEnd = (event) => {
        const { active, over } = event;
        if (!over || active.id === over.id) return;
        setSortedChapters((prev) => {
            const oldIndex = prev.findIndex((c) => c.id === active.id);
            const newIndex = prev.findIndex((c) => c.id === over.id);
            return arrayMove(prev, oldIndex, newIndex);
        });
        setIsOrderChanged(true);
    };
    const navigate = useNavigate()
    const handleLessonClick = (lessonId, chapterId) => {
        navigate("/courses/update-lesson", { state: { lessonId, chapterId, courseId: selectCourses?.id } })
    }

    // ─── Course saqlash ──────────────────────────────────────────────────────────
    const updateCourse = () => {
        const price = parseFloat(courseName?.price);
        if (isNaN(price)) { toast.error("Price noto'g'ri kiritilgan"); return; }
        const formData = new FormData();
        formData.append("price", price);
        formData.append("mentor_id", selectedMentorId);
        if (selectedFile) formData.append("photo", selectedFile);
        axios.put(`${MAIN_URL}/courses/update/${courseName?.id}`, formData, {
            headers: { "Content-Type": "multipart/form-data", Authorization: `Bearer ${TOKEN}` },
        })
            .then(() => toast.success("Course updated successfully!"))
            .catch(() => toast.error("There was an error updating the course!"));
    };

    // ─── Chapter saqlash (eski — faqat bitta til) ────────────────────────────────
    const updateChapter = () => {
        const formDat = new FormData()
        if (chapterFile) formDat.append("exam_pdf", chapterFile);
        formDat.append("title", chapterName?.title)
        axios.put(`${MAIN_URL}/courses/chapters/${chapterName?.id}`, formDat, {
            headers: { "Content-Type": "multipart/form-data", Authorization: `Bearer ${TOKEN}` },
        }).then(() => {
            toast.success("Chapter updated successfully!")
            setChapterUpLoad(false)
            setChapters(prev => prev.map(ch => ch.id === chapterName?.id ? { ...ch, title: chapterName?.title } : ch));
            setChapterEdit(false);
            setChapterFile("")
        }).catch((err) => { console.log(err); setChapterUpLoad(false) })
    }

    // ─── Course translation handlers ─────────────────────────────────────────────
    const handleTranslationChange = (lang, field, value) => {
        setTranslations((prev) => ({ ...prev, [lang]: { ...prev[lang], [field]: value } }));
    };
    const updateTranslation = (lang) => {
        const t = translations[lang];
        if (!t.title.trim()) { toast.warning("Title bo'sh bo'lishi mumkin emas!"); return; }

        // translation_id yo'q — POST (yangi yaratish)
        if (!t.translation_id) {
            axios.post(
                `${MAIN_URL}/courses/add-translations/${courseId}`,
                [{ title: t.title, description: t.description, language: lang }],
                { headers: { "Content-Type": "application/json", Authorization: `Bearer ${TOKEN}` } }
            )
                .then(() => {
                    toast.success(`${langFlags[lang]} ${lang.toUpperCase()} tarjimasi yaratildi!`);
                    // Yangi translation_id ni olish uchun kursni qayta yuklaymiz
                    api.get(`/courses/detail/${courseId}`, {
                        headers: { Authorization: `Bearer ${TOKEN}` }
                    }).then((res) => {
                        const data = res.data;
                        if (data.translations && Array.isArray(data.translations)) {
                            const mapped = {
                                uz: { title: "", description: "", translation_id: null },
                                ru: { title: "", description: "", translation_id: null },
                                en: { title: "", description: "", translation_id: null },
                            };
                            data.translations.forEach((tr) => {
                                if (mapped[tr.language] !== undefined) {
                                    mapped[tr.language] = {
                                        title: tr.title || "",
                                        description: tr.description || "",
                                        translation_id: tr.id,
                                    };
                                }
                            });
                            setTranslations(mapped);
                        }
                    });
                })
                .catch((err) => toast.error(`Xatolik: ${err.message}`));
            return;
        }

        // translation_id bor — PUT (mavjudni yangilash)
        axios.put(
            `${MAIN_URL}/courses/update-translations/${t.translation_id}`,
            { title: t.title, description: t.description, language: lang },
            { headers: { "Content-Type": "application/json", Authorization: `Bearer ${TOKEN}` } }
        )
            .then(() => toast.success(`${langFlags[lang]} ${lang.toUpperCase()} tarjimasi saqlandi!`))
            .catch((err) => toast.error(`Xatolik: ${err.message}`));
    };
    // ─────────────────────────────────────────────────────────────────────────────
    console.log("bu chapters:", sortedChapters);

    const backButton = (
        <div>
            <Button variant="ghost" size="sm" leftIcon={<ArrowLeft />} onClick={() => navigate('/courses')}>
                Orqaga
            </Button>
        </div>
    );

    // Kurs id yo'q (havola yangi tabda ochilgan) — so'rov mantiqi o'zgarmaydi, faqat ko'rinish.
    if (!courseId) {
        return (
            <div className="ui-edit-course">
                {backButton}
                <Card padding="none">
                    <EmptyState
                        icon={<BookOpen />}
                        title="Kurs tanlanmagan"
                        description="Kurslar ro'yxatidan tahrirlash uchun kursni tanlang"
                        action={<Button size="sm" onClick={() => navigate('/courses')}>Kurslar ro'yxati</Button>}
                    />
                </Card>
            </div>
        );
    }

    const imageSrc = image
        ? (image.startsWith("blob") || image.startsWith("http") ? image : `${MAIN_URL}/${image}`)
        : null;
    const chapterModalTitle = chapterTranslationModal?.translations?.find((t) => t.language === "uz")?.title;

    return (
        <div className="ui-edit-course">
            {backButton}
            <PageHeader title={translations.uz.title || "Kursni tahrirlash"} subtitle="Kursni tahrirlash" />

            {/* ─── Asosiy ma'lumotlar ─── */}
            <Card title="Asosiy ma'lumotlar">
                <div className="ui-edit-course__grid">
                    <Input
                        label="Narx"
                        type="number"
                        min={0}
                        value={courseName.price}
                        onChange={(e) => setCourseName(prev => ({ ...prev, price: e.target.value }))}
                        hint={formatPrice(courseName.price) || undefined}
                    />
                    <Select label="Mentor" value={selectedMentorId} onChange={(e) => setSelectedMentorId(e.target.value)}>
                        <option value={selectedMentorId}>{courseName.mentor}</option>
                        {mentors?.map((mentor) => (
                            <option value={mentor?.id} key={mentor.id}>{mentor?.first_name} {mentor?.last_name}</option>
                        ))}
                    </Select>
                </div>

                <div className="ui-edit-course__image">
                    <span className="ui-edit-course__label">Rasm</span>
                    <div className="ui-edit-course__image-row">
                        <button
                            type="button"
                            className={`ui-edit-course__preview ${isHovered && imageSrc ? "ui-edit-course__preview--hover" : ""}`}
                            onMouseEnter={() => setIsHovered(true)}
                            onMouseLeave={() => setIsHovered(false)}
                            onClick={handleImgOpen}
                            disabled={!imageSrc}
                            aria-label="Rasmni kattalashtirib ko'rish"
                        >
                            <CourseThumbnail src={imageSrc} alt={imageSrc ? "Course" : ""} className="ui-edit-course__preview-media" />
                            {imageSrc && (
                                <span className="ui-edit-course__preview-zoom" aria-hidden="true">
                                    <ZoomIn />
                                </span>
                            )}
                        </button>
                        <div className="ui-edit-course__image-actions">
                            <label className="ui-btn ui-btn--secondary ui-btn--md ui-edit-course__upload">
                                <span className="ui-btn__icon"><ImageUp /></span>
                                <span className="ui-btn__label">Rasmni almashtirish</span>
                                <input onChange={handleImgChange} className="ui-edit-course__file" accept="image/*" type="file" />
                            </label>
                            {selectedFile && <span className="ui-edit-course__muted">{selectedFile.name}</span>}
                        </div>
                    </div>
                </div>

                <div className="ui-edit-course__actions">
                    <Button onClick={updateCourse}>Saqlash</Button>
                </div>
            </Card>

            {/* ─── Course Translations ─── */}
            <Card title="Tarjimalar">
                <SegmentedControl
                    aria-label="Til"
                    options={LANGS.map((lang) => langOption(lang, Boolean(translations[lang].translation_id)))}
                    value={activeLanguage}
                    onChange={setActiveLanguage}
                />
                {LANGS.map((lang) => (
                    <div key={lang} style={{ display: activeLanguage === lang ? "block" : "none" }}>
                        <div className="ui-edit-course__fields">
                            <Input
                                label={`Sarlavha (${lang.toUpperCase()})`}
                                type="text"
                                value={translations[lang].title}
                                onChange={(e) => handleTranslationChange(lang, "title", e.target.value)}
                                placeholder={`${lang.toUpperCase()} tilida sarlavha...`}
                            />
                            <div className="ui-edit-course__editor-field">
                                <span className="ui-edit-course__label">Tavsif ({lang.toUpperCase()})</span>
                                <ReactQuill
                                    value={translations[lang].description}
                                    onChange={(val) => handleTranslationChange(lang, "description", val)}
                                    className="ui-edit-course__editor"
                                    placeholder={`${lang.toUpperCase()} tilida tavsif...`}
                                />
                            </div>
                        </div>
                        <div className="ui-edit-course__actions">
                            <Button onClick={() => updateTranslation(lang)}>
                                Saqlash ({lang.toUpperCase()})
                            </Button>
                        </div>
                    </div>
                ))}
            </Card>

            {/* ─── Chapterlar ─── */}
            <Card
                title="Boblar va darslar"
                actions={<Badge variant="neutral" size="sm">{sortedChapters?.length || 0} ta bob</Badge>}
            >
                <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
                    <SortableContext items={(chapters || []).map(ch => ch.id)}>
                        <div className="ui-chapter-list">
                            {sortedChapters?.map((chapter, index) => (
                                <SortableChapter
                                    key={chapter.id}
                                    chapter={chapter}
                                    index={index}
                                    handleChapter={handleChapter}
                                    activeChapter={activeChapter}
                                    chapterEdit={chapterEdit}
                                    handleChapterEdit={handleChapterEdit}
                                    handleFileChange={handleFileChange}
                                    handleUpCapter={handleUpCapter}
                                    updateChapter={updateChapter}
                                    lessons={lessons}
                                    setChapterName={setChapterName}
                                    chapterName={chapterName}
                                    handleLessonClick={handleLessonClick}
                                    // Chapter translation modal ochish uchun prop
                                    onOpenTranslationModal={openChapterTranslationModal}
                                />
                            ))}
                        </div>
                    </SortableContext>
                </DndContext>
            </Card>

            {/* ─── Chapter Translation Modal ────────────────────────────────────────── */}
            <Modal
                open={Boolean(chapterTranslationModal)}
                onClose={closeChapterTranslationModal}
                title="Bobni tahrirlash"
                subtitle={chapterModalTitle}
                size="md"
                footer={
                    <>
                        <Button variant="secondary" onClick={closeChapterTranslationModal}>
                            Bekor qilish
                        </Button>
                        <Button onClick={() => updateChapterTranslation(activeChapterLang)}>
                            Saqlash ({activeChapterLang.toUpperCase()})
                        </Button>
                    </>
                }
            >
                <div className="ui-edit-course__fields">
                    <SegmentedControl
                        aria-label="Til"
                        options={LANGS.map((lang) => langOption(lang, Boolean(chapterTranslations[lang].translation_id)))}
                        value={activeChapterLang}
                        onChange={setActiveChapterLang}
                    />
                    {LANGS.map((lang) => (
                        <div key={lang} style={{ display: activeChapterLang === lang ? "block" : "none" }}>
                            <Input
                                label={`Bob nomi (${lang.toUpperCase()})`}
                                type="text"
                                value={chapterTranslations[lang].title}
                                onChange={(e) =>
                                    handleChapterTranslationChange(lang, e.target.value)
                                }
                                placeholder={`${lang.toUpperCase()} tilida chapter nomi...`}
                            />
                        </div>
                    ))}
                    {/* PDF — faqat bitta fayl barcha tillarga umumiy */}
                    <div className="ui-edit-course__editor-field">
                        <span className="ui-edit-course__label">Imtihon PDF (ixtiyoriy)</span>
                        <label className="ui-edit-course__pdf">
                            <FileText aria-hidden="true" />
                            <span>
                                {chapterTranslationFile
                                    ? chapterTranslationFile.name
                                    : "PDF faylni tanlang..."}
                            </span>
                            <input
                                type="file"
                                accept="application/pdf"
                                className="ui-edit-course__file"
                                onChange={(e) => {
                                    const file = e.target.files[0];
                                    if (file) setChapterTranslationFile(file);
                                }}
                            />
                        </label>
                    </div>
                </div>
            </Modal>

            {/* ─── Rasm Modal ─── */}
            <Modal open={imgOpen && Boolean(imageSrc)} onClose={handleImgOpen} title="Kurs rasmi" size="lg" closeOnOverlayClick>
                {imageSrc && <img className="ui-edit-course__full-image" src={imageSrc} alt="img" />}
            </Modal>
        </div>
    );
}

export default UpdateCourse;